module.exports = __webpack_public_path__ + "img/home_recom_gold.2c43dd93.png";